import { PERSONAL_OWNER_EMAIL, type PermissionKey, type PublicUser } from '@otter/shared';

export function hasPermission(user: PublicUser | null, key: PermissionKey): boolean {
  if (!user) return false;
  if (user.isSystemAdmin) return true;
  return user.role.permissions[key] === true;
}

// True when the actor can see (and optionally filter by) other users' data.
export function canSeeOthers(user: PublicUser | null): boolean {
  if (!user) return false;
  return user.isSystemAdmin || user.role.scope === 'team' || user.role.scope === 'all';
}

// Owner of the private personal-finance module. Locked to the single user whose
// email is PERSONAL_OWNER_EMAIL (the same lock the API's requirePersonalOwner
// enforces). Not a role permission on purpose: this is a personal feature, never
// assignable. The real guard is the API 404; this only hides the UI.
export function isPersonalOwner(user: PublicUser | null): boolean {
  return !!user && user.email.toLowerCase() === PERSONAL_OWNER_EMAIL;
}
